"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
const base_models_1 = require("@integration/base-models");
const BaseOfferFS_1 = require("../BaseOfferFS");
class GetNextBestOfferResponseOfferV3 extends BaseOfferFS_1.BaseOfferFS {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => offerstore_api_models_1.PropositionProduct),
    tslib_1.__metadata("design:type", Array)
], GetNextBestOfferResponseOfferV3.prototype, "products", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({
        example: 4,
        description: 'Offer ranking, based on the offer feedback for the specific offer.',
    }),
    tslib_1.__metadata("design:type", Number)
], GetNextBestOfferResponseOfferV3.prototype, "ranking", void 0);
exports.default = GetNextBestOfferResponseOfferV3;
